var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 7,
    viewBox: "0 0 20 7",
    fill: "#E6E6E6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4 1.13333L6.4 3.8C4.88916 5.81445 2.51806 7 0 7H20C17.4819 7 15.1108 5.81445 13.6 3.8L11.6 1.13333C10.8 0.0666667 9.2 0.066667 8.4 1.13333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardArrowIcon);
export default __webpack_public_path__ + "static/media/card_arrow_icon.43012c74823a3cba28ea3914b22b1450.svg";
export { ForwardRef as ReactComponent };